import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { ModelsViewWrapperComponent } from '@app/pages/quote/standard-quote/read-only/models-view/models-view-wrapper.component';

@Component({
  selector: 'app-models-view-mobile',
  templateUrl: './models-view-mobile.component.html',
  styleUrls: ['./models-view-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModelsViewMobileComponent extends ModelsViewWrapperComponent {
}
